import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// common
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
// scss
import './../../../common/CommonList/Table.scss';

const columns = [
	{
		key: null,
		label: 'S.No'
	},
	{
		key : 'user_name',
		label : 'User Name'
	},
	{
		key: 'created_date',
		label: 'created date'
	}
];

const ParticipantTable = ({ batchPartList, deleteBatchPart, manageUser }) => {
	if(batchPartList && batchPartList.length > 0) {
		return (
			<table className="table ParticipantTable">
				<thead>
					<tr>
						{columns.map((item, i) => (
							<th key={i} id={item.key}>{item.label}</th>
						))}
						<th></th>
					</tr>
				</thead>
				<tbody>
					{batchPartList.map((item, i) => (
						<tr key={i}>
							{columns.map((column, j) => {
								if (!column.key) {
									return <td key={j}>{i + 1}</td>;
								}
								if (column.key === 'created_date') {
									return <td key={j}>{moment(item[column.key]).format('DD MMM YYYY')}</td>;
								}
								return <td key={j}>{item[column.key]}</td>;
							})}
							<td className="text-right">
								{/* <CustomButton
									iconOnly
									iconName='delete'									
									onClick={() => deleteBatchPart(item.id)}
								/> */}
								<CustomButton
								name='delete'
								iconOnly
								iconName='delete'
								onClick={() => manageUser(true, 'delete', item.id)}
							/>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		);
	}
	return (<Loader />);
}

ParticipantTable.propTypes = {
	batchPartList: PropTypes.instanceOf(Array),
	deleteBatchPart: PropTypes.func
};

ParticipantTable.defaultProps = {
	batchPartList: [],
	deleteBatchPart: () => {}
};

export default ParticipantTable;



// WEBPACK FOOTER //
// ./components/BatchParticipant/ParticipantList/ParticipantTable.js